import React, { useCallback, useState } from 'react';
import { Table, Space, Button, Popconfirm } from 'antd';
import { TableWrapper } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import { ColumnsType } from 'antd/lib/table/interface';
import { FileExcelOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';

interface FormItemProps {
  lecturerList: any[] | undefined;  
  hiddenColumns: string[];  
  year: string;
  onCellClick: (month, value) => void;
}

const SALESLTTable = ({lecturerList, hiddenColumns, year, onCellClick}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const columns: ColumnsType<any> = [
    {
      title: '강사',
      dataIndex: 'lecturer_name',
      key: 'lecturer_name',
      width: '70px',
      align: 'center',
      onCell: (record, index) => ({
        rowSpan: record.group_type === '총 시간' ? 5 : !!record.group_type? 0: 1,
      }),      
    },  
    {
      title: '구분',
      dataIndex: 'group_type',
      key: 'group_type',
      width: '100px',
      align: 'center',
    },   
    {
      title: '1월',
      dataIndex: 'month_01',
      key: 'month_01',
      width: 'auto',
      align: 'right',      
      render: (price, record) => {
        return (
          (price && price > 0)?<a onClick={()=> onCellClick('01', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }         
    },       
    {
      title: '2월',
      dataIndex: 'month_02',
      key: 'month_02',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('02', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '3월',
      dataIndex: 'month_03',
      key: 'month_03',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('03', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '4월',
      dataIndex: 'month_04',
      key: 'month_04',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('04', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '5월',
      dataIndex: 'month_05',
      key: 'month_05',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('05', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '6월',
      dataIndex: 'month_06',
      key: 'month_06',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('06', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '7월',
      dataIndex: 'month_07',
      key: 'month_07',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('07', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '8월',
      dataIndex: 'month_08',
      key: 'month_08',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)?<a onClick={()=> onCellClick('08', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '9월',
      dataIndex: 'month_09',
      key: 'month_09',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('09', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '10월',
      dataIndex: 'month_10',
      key: 'month_10',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('10', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '11월',
      dataIndex: 'month_11',
      key: 'month_11',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('11', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '12월',
      dataIndex: 'month_12',
      key: 'month_12',
      width: 'auto',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('12', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    }, 
    {
      title: '합계/평균',
      dataIndex: 'month_sum',
      key: 'month_sum',
      width: '100px',
      align: 'right',    
      render: (price, record) => {
        return (
          (price && price > 0)? <a onClick={()=> onCellClick('ALL', record.lecturer_srl)}>{price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</a> : ''
        )
      }  
    },                                                 
  ];

  /* ======================================================
  * events
  * ====================================================== */ 
  const onExcelDownload = () => {
    if (!!lecturerList) {
      const header: string[] = [];
      const datas: any[] = [];
      const merges: any[] = [];

      header.push('강사');
      header.push('구분');
      header.push('1월');
      header.push('2월');
      header.push('3월');
      header.push('4월');
      header.push('5월');
      header.push('6월');
      header.push('7월');
      header.push('8월');
      header.push('9월');
      header.push('10월');
      header.push('11월');
      header.push('12월');
      header.push('합계/평균');
  
      let cnt = 0;
      lecturerList.forEach(({lecturer_name, group_type, month_01, month_02, month_03, month_04, month_05, month_06, month_07, month_08, month_09, month_10, month_11, month_12, month_sum }) => {
        const newItem = {
          '강사': lecturer_name,
          '구분': group_type,
          '1월': month_01,
          '2월': month_02,
          '3월': month_03,
          '4월': month_04,
          '5월': month_05,
          '6월': month_06,
          '7월': month_07,
          '8월': month_08,
          '9월': month_09,
          '10월': month_10,
          '11월': month_11,
          '12월': month_12,
          '누계': month_sum,
        }
        datas.push(newItem);  
        
        if (cnt % 6 == 0) {
          merges.push({s: {c:0, r:cnt+1}, e: {c:0, r:cnt+5}});        
        }
        cnt++;
      })

      const book = XLSX.utils.book_new();
      const nurses = XLSX.utils.json_to_sheet(
        datas, 
        { 
          header : header, 
          skipHeader : false 
        } 
      );
  
      nurses["!cols"] = [
        { wpx : 150, } 
      , { wpx : 150, } 
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_01') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_02') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_03') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_04') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_05') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_06') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_07') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_08') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_09') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_10') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_11') > -1 }
      , { wpx : 100, hidden: hiddenColumns.findIndex((col)=>col === 'month_12') > -1 }
      , { wpx : 100 }
      ]
  
      if (merges.length > 0) {
        nurses["!merges"]  = merges;   
      }

      XLSX.utils.book_append_sheet( book, nurses, "NURSES" );
      XLSX.writeFile( book, 'Management_강의평가_강의시간_'+year+'.xlsx');       
    }
  }

  /* ======================================================
  * hooks
  * ====================================================== */
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Space style={{width:'100%', justifyContent:'end', marginTop:'20px'}}>
        <Space>
          <Button icon={<FileExcelOutlined />} onClick={onExcelDownload}>엑셀다운로드</Button>
        </Space>              
      </Space>        
      <TableWrapper isSearch={false}>
        <Table
          tableLayout="fixed"
          dataSource={lecturerList}
          bordered
          columns={columns.filter((item) => hiddenColumns.findIndex((col)=>col === item.key) < 0)}
          pagination={false}
          style={{ width: '100%', overflowX: 'auto', minWidth: 600 }}
          className="columnCenterFixTable clickable"
          showSorterTooltip={false}
        />
      </TableWrapper>  
    </Space>
  );
};

export default SALESLTTable;
